/*
 * Teachers on the provider Schools page (TDI-621, B1): pure helpers shared
 * by RmsSchoolTeachersPanel and its tests.
 */

// Status shown per record: colour, icon and label together (meaning never
// rides on colour alone). Keys are the server's providerStatus values.
export const PROVIDER_TEACHER_STATUS = {
  active: { label: 'Active', className: 'bg-green-100 text-green-800', icon: 'check' },
  email_sent: { label: 'Email sent', className: 'bg-amber-100 text-amber-800', icon: 'mail' },
  left: { label: 'No longer at this school', className: 'bg-gray-100 text-gray-700', icon: 'minus' },
};

export const ALL_SCHOOLS = '';

/** The rows for the School filter: every school, or one. */
export function filterTeachersBySchool(teachers, school) {
  const list = teachers || [];
  if (!school) return list;
  return list.filter((t) => (t.schoolName || '') === school);
}

/** "2 November 2026" from an ISO time; null when never. */
export function formatSignedIn(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

/** The form fields "Change details" sends, trimmed; phone null when blank. */
export function teacherDetailsPayload(form) {
  return {
    firstName: String(form.firstName || '').trim(),
    lastName: String(form.lastName || '').trim(),
    email: String(form.email || '').trim(),
    jobRole: String(form.jobRole || '').trim(),
    phone: String(form.phone || '').trim() || null,
  };
}

/**
 * The leaver toast's second line, for the school rather than "you": forms
 * go back to the school's SENCO (B1).
 */
export function formsBackToSchoolLine(n, school) {
  const where = school ? `${school}'s SENCO` : "the school's SENCO";
  if (n === 1) return `1 unfinished form is back with ${where}.`;
  return `${n} unfinished forms are back with ${where}.`;
}
